import { useEffect, useState } from "react";
//#region src/common/utils/hooks/useIsMobile.ts
var MOBILE_BREAKPOINT = 991;
var useIsMobile = () => {
	const [windowWidth, setWindowWidth] = useState(0);
	useEffect(() => {
		const handleResize = () => {
			setWindowWidth(window.innerWidth);
		};
		window.addEventListener("resize", handleResize);
		handleResize();
		return () => window.removeEventListener("resize", handleResize);
	}, []);
	return windowWidth < MOBILE_BREAKPOINT;
};
//#endregion
export { useIsMobile };

//# sourceMappingURL=useIsMobile.esm.js.map